<template>
  <div class="store-locator-wrapper">
    <!-- Show dropdown with store info if store is selected -->
    <dropdown v-if="currentStoreObj && currentStoreObj.storeName" :class="`filter filter-dropdown ${config.name}`" :closeOnClick="true" v-bind="config.attrs" data-tour-item="storeLocator">

      <template #btn>

        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <span v-if="displayMode === 'desktop'" class="btn__store-name">{{ currentStoreObj.storeName }}</span>

        <span v-if="displayMode === 'desktop'" class="btn__store-address"><span v-if="currentStoreObj.address">{{ currentStoreObj.address }}, </span><span v-if="currentStoreObj.city">{{ currentStoreObj.city }}, </span><span v-if="currentStoreObj.province">{{ currentStoreObj.province }}</span></span>
      </template>
      <template v-if="displayMode !== 'desktop'" #icon><span></span></template>

      <template #body>
        <div class="current-store-body">

            <div class="store-name">{{ currentStoreObj.storeName }}</div>
            <div class="store-address">
              <p><span v-if="currentStoreObj.address">{{ toTitleCase(currentStoreObj.address) }},<br></span>
                <span v-if="currentStoreObj.city">{{ toTitleCase(currentStoreObj.city) }}, </span><span v-if="currentStoreObj.province">{{ currentStoreObj.province }}</span></p>
            </div>
            <button class="change-store" @click="handleChangeStore()">{{ content.storeLocator.changeStore }}</button>

        </div>

      </template>
    </dropdown>

    <!-- Show select store button if no store is selected -->
    <button v-else class="select-store-btn" @click="handleChangeStore()" data-tour-item="storeLocator">
      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{ lang.storeLocator.selectStore }}</span>
    </button>
  </div>
</template>

<script>
import Dropdown from "@/components/bp-vuejs-dropdown/Dropdown.vue"
import featureMixin from "@/mixins/featureMixin";
import {mapActions, mapGetters, mapState} from "vuex";
import { toTitleCase } from "@/utils";

export default {
  name: "StoreLocator-Dropdown",
  mixins: [featureMixin],
  components: { Dropdown },
  data() {
    return {
      featurePath: 'storeLocator',
    }
  },
  computed: {
    ...mapGetters('screen', ['displayMode']),
    ...mapGetters(['content', 'lang']),
    ...mapState(['currentStoreObj']),
  },
  methods: {
   ...mapActions('storeLocator',['toggleStoreSelection']),
    toTitleCase,
    handleChangeStore(){
      this.toggleStoreSelection(true)
    }
  },
}
</script>

<style lang="scss">

.store-locator-wrapper {
  // Standalone button styling (when no store is selected)
  .select-store-btn {
    // custom
  }
  @media screen and (max-width: 1023px) {
    margin-left: 0.6em;
    margin-right: 0 !important;
  }

  // Dropdown button styling (when store is selected)
  .bp-dropdown__btn {
    // max-width: 132px;

    @media screen and (min-width: 1024px) {
      display: grid;
      row-gap: 2px;
      grid-template-columns: auto 1fr auto;
      border: none;
    }
    @media screen and (max-width: 1023px) {
      padding: 5px 0 5px 3px;
    }


    .btn__store-name {
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .bp-dropdown__icon {
      order: 3;
      align-self: end;
    }

    .btn__store-address {
      order: 4;
      grid-column: 1 / 3;
      max-width: 132px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
    }
  }

  // Style the dropdown body if needed
  .bp-dropdown__body {
    text-align: left;
    border-radius: 4px;
    max-width: 316px;
    padding: 16px 20px;
  }
}

.current-store-body {
  display:flex;
  width:100%;
  flex-direction: column;
  align-items: start;

  .store-name {
    line-height: 1.5em;
    color: var(--secondary-color);
    text-transform: uppercase;
    font-weight: bold;
  }
  .store-address {
    color: #4c4c4c;
    display: flex;

    span {
      text-align: left;
    }
  }
  .change-store {
    margin-top: 20px;
    padding: 10px 1.2em;
    background: var(--secondary-color);
    color: white;
    width:60%;
  }
}
</style>
